<template>
	<div class="d-flex justify-content-center align-items-center pagination">
		<a v-if="(currentPage > 0)" href="#" class="bg-icon pagination-prev" @click.prevent="$emit('prev-page')" aria-role="navigation" :aria-label="'Go to page ' + (currentPage-1)"> </a>
		<span v-if="(currentPage == 0)" class="bg-icon pagination-prev inactive"> </span>
		<span class="pagination-text" :aria-label="'Current page is ' + (currentPage + 1) + ' of ' + (maxPage)">{{currentPage + 1}} of {{maxPage}}</span>
		<a v-if="(currentPage != (maxPage-1) )" href="#" class="bg-icon pagination-next" @click.prevent="$emit('next-page')" aria-role="navigation" :aria-label="'Go to page ' + (currentPage+1)"> </a>
		<span v-if="(currentPage == maxPage-1)" class="bg-icon pagination-next inactive"> </span>
	</div>
</template>

<style lang="scss">
.pagination {
	.pagination-prev {
		background-image: get-icon( 'arrow-left', $black );
		width: 12px;
		height: 14px;

		&.inactive {
			opacity: 0.5;
		}
	}

	.pagination-next {
		background-image: get-icon( 'arrow-right', $black );
		width: 12px;
		height: 14px;
		&.inactive {
			opacity: 0.5;
		}
	}

	.pagination-text {
		margin: 1em;
		color: $navyBlue;
	}

}
</style>

<script>
	export default {
		props: {
			currentPage: {
				type: Number,
				default: 1
			},
			maxPage: {
				type: Number,
				default: 5
			}
		}
	}
</script>